import Vue from 'vue';
import getInitialState from './state';
import isEmpty from 'lodash.isempty';
import { v4 as uuidv4 } from 'uuid';

export default {
  ADD_RPODUCT: (state, productInfo) => {
    Vue.set(state, 'products', [productInfo, ...state.products]);
  },

  REMOVE_PRODUCT: (state, id) => {
    const index = state.products.findIndex((stateProduct) => id === stateProduct._id);
    if (index > -1) {
      state.products.splice(index, 1);
    }
  },

  REMOVE_IFRAME_PRODUCT: (state, id) => {
    const index = state.iframeProducts.findIndex((stateProduct) => id === stateProduct.shopifyVariantId);
    if (index > -1) {
      state.iframeProducts.splice(index, 1);
    }
  },
  SET_PRODUCTS: (state, products) => (state.products = products),
  SET_SHARED_PRODUCTS: (state, products) => (state.sharedProducts = products),
  SET_LOGIN_DATA: (state, credentials) => {
    const categories = credentials.categories;
    if (categories) {
      state.categories = categories;
      delete credentials.categories;
    }
    Vue.set(state, 'credentials', credentials);
    localStorage.setItem('credentials', JSON.stringify(credentials));
  },

  SET_LOADING_FLAG: (state, flag) => {
    state.isLoading = flag;
  },

  SET_CATEGORIES: (state, categories) => {
    state.categories = categories;
  },

  ADD_NEW_CATEGORY: (state, category) => {
    state.categories.push(category);
  },

  ADD_PRODUCT_ALARM: (state, productId) => {
    Vue.set(state.alarmProducts, productId, true)
    localStorage.setItem('alarmProducts', JSON.stringify(state.alarmProducts));
  },

  INIT_PRODUCT_ALARMS: (state) => {
    const alarms = localStorage.getItem('alarmProducts');
    state.alarmProducts = alarms ? JSON.parse(alarms) : [];
  },

  REMOVE_PRODUCT_ALARM: (state, productId) => {
    Vue.delete(state.alarmProducts, productId);
    localStorage.setItem('alarmProducts', JSON.stringify(state.alarmProducts));
  },

  EDIT_RPODUCT: (state, product) => {
    const stateProductIndex = state.products.findIndex((stateProduct) => stateProduct._id === product._id);
    if (stateProductIndex > -1) {
      Vue.set(state, `products[${stateProductIndex}]`, product);
    }
  },

  ADD_SHARE_BY_ME_PRODUCT: (state, product) => {
    Vue.set(state, `productsSharedByMe[${product.productId}]`, true);
  },

  REMOVE_CATEGORY: (state, category) => {
    const index = state.categories.findIndex((cat) => cat === category);
    if (index > -1) {
      state.categories.splice(index, 1);
    }
  },

  REMOVE_REACTION: (state, reaction) => {
    let shareProduct;
    shareProduct = state.sharedProducts.find((stateProduct) => stateProduct.sharedDataId === reaction.sharedDataId);
    if (isEmpty(shareProduct)) {
      return;
    }

    Vue.delete(shareProduct.data.likes, reaction.id);
  },

  REMOVE_COMMENT: (state, comment) => {
    let shareProduct;

    if (comment.isMyProduct) {
      shareProduct = state.products.find((stateProduct) => stateProduct.sharedDataId === comment.sharedDataId);
    } else {
      shareProduct = state.sharedProducts.find((stateProduct) => stateProduct.sharedDataId === comment.sharedDataId);
    }

    if (isEmpty(shareProduct)) {
      return;
    }

    Vue.delete(shareProduct.data.comments, comment.id);
  },

  ADD_REACTION: (state, reaction) => {
    let shareProduct;

    shareProduct = state.sharedProducts.find((stateProduct) => stateProduct.sharedDataId === reaction.sharedDataId);
    if (isEmpty(shareProduct)) {
      return;
    }

    Vue.set(shareProduct.data.likes, reaction.id, reaction);
  },

  ADD_COMMENT: (state, comment) => {
    let shareProduct;

    if (comment.isMyProduct) {
      shareProduct = state.products.find((stateProduct) => stateProduct.sharedDataId === comment.sharedDataId);
      delete comment.isMyProduct;
    } else {
      shareProduct = state.sharedProducts.find((stateProduct) => stateProduct.sharedDataId === comment.sharedDataId);
    }
    if (isEmpty(shareProduct)) {
      return;
    }

    Vue.set(shareProduct.data.comments, comment.id, comment);
  },

  CLEAR_STATE: (state) => {
    const newState = getInitialState();
    newState.isIframe = state.isIframe;
    newState.iframeProducts = JSON.parse(JSON.stringify(state.iframeProducts));
    newState.iframeParentUrl = state.iframeParentUrl;

    Object.assign(state, newState);
    localStorage.setItem('credentials', '');
    localStorage.setItem('listId', '');
  },

  ADD_BANNER: (state, options) => {
    // Using unshift to push to the head of the list in order to make the flash pop at the top of the other messages
    state.banners.unshift(options);
  },

  REMOVE_BANNER: (state, options) => {
    const index = state.banners.indexOf(options);
    state.banners.splice(index, 1);
  },

  SET_IFRAME_FLAG: (state, flag) => {
    state.isIframe = true;
  },

  SET_IFRAME_PRODUCTS: (state, products) => {
    state.iframeProducts = products;
  },

  SET_IFRAME_PARENT_URL: (state, merchantUrl) => {
    state.iframeParentUrl = merchantUrl;
  },


};
